import Vue from 'vue'
import App from './App.vue'
import router from './router'
import api from "./api";
import store from './store'
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './globa-style.scss'

if (window.self === window.top) {
    //
} else {
    // import Popper from 'popper.js'

    Vue.config.productionTip = false

    Vue.use(BootstrapVue)
    Vue.use(IconsPlugin)
    // Vue.use(Popper)

    Vue.mixin({
        methods: {
            makeToast: function (title, message, variant = null) {
                this.$bvToast.toast(`${message}`, {
                    title: title,
                    variant: variant,
                    autoHideDelay: 5000,
                    appendToast: false,
                    noCloseButton: true
                })
            },
            hasPermission: function (name) {
                return this.$store.state.permissions.includes(name);
            },
        }
    })

    let api_url = "api_url"
    let gateway_api_url = "gateway_api_url"
    let parent_origin = "parent_origin"
    if (process.env.NODE_ENV === "development") {
        api_url = "api_url_dev"
        gateway_api_url = "gateway_api_url_dev"
        parent_origin = "parent_origin_dev"
    }
    // Receives the logged-in user's JWT from the GatewayWEB parent window (see
    // GatewayWEB's IframeViewer.vue), so this app can call GatewayAPI's
    // permission-gated Send/Email endpoints on the user's behalf.
    // Registered synchronously (before config.json resolves) since the parent sends this
    // on the iframe's load event, which can fire before the async config fetch completes.
    let resolvedConfig = null;
    let pendingAuthEvent = null;

    const handleAuthMessage = (event) => {
        if (!event.data || event.data.type !== 'lcs-auth') return;
        if (!resolvedConfig) {
            pendingAuthEvent = event;
            return;
        }
        if (event.origin !== resolvedConfig[parent_origin]) return;

        api.setAuthToken(event.data.token);
        api.getMyPermissions(
            (permissions) => store.commit('setPermissions', permissions),
            () => store.commit('setPermissions', [])
        );
    };
    window.addEventListener('message', handleAuthMessage);

    fetch('/config.json')
        .then(res => res.json())
        .then(config => {
            api.Url = config[api_url]
            api.GatewayUrl = config[gateway_api_url]
            resolvedConfig = config;

            if (pendingAuthEvent) {
                handleAuthMessage(pendingAuthEvent);
                pendingAuthEvent = null;
            }

            new Vue({
                data: () => ({
                    urlConfig: config
                }),
                router,
                store,
                render: h => h(App)
            }).$mount('#app')
        })
}